import { Component, OnDestroy, OnInit, ViewChild, TemplateRef, ChangeDetectorRef, ViewEncapsulation, ElementRef, Input, Pipe, PipeTransform, Output, EventEmitter, AfterViewInit, OnChanges } from '@angular/core';
import { UntypedFormGroup, FormControl, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms'
import { GlobalSearchService } from '../../services/globalsearchservice.service'
import { PaymentsService } from '../../services/payments.service'
import { SystemService } from '../../services/system.service'
import { Terminal } from '../../services/terminal.service'
import { UsersService } from '../../services/users.service'
import { MatButtonToggleChange } from '@angular/material/button-toggle'
import { debounceTime, distinctUntilChanged, switchMap, takeUntil } from 'rxjs/operators';
import { ThisReceiver } from '@angular/compiler';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TerminalTransactionModalComponent } from '../terminal-transaction-modal/terminal-transaction-modal.component';
import { resolveDefaultBankAccountCode } from '../../utils/bank-account-default';

@Component({
	selector: 'app-pos-order-payments',
	templateUrl: './pos-order-payments.component.html',
	styleUrls: ['./pos-order-payments.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class PosOrderPaymentsComponent implements OnInit, OnChanges {

	paymentForm: UntypedFormGroup;
	numberposition = 1;

	@Input() order_header: any = [];
	@Input() items: any = [];
	@Input() totals: any;
	@Input() pos: any = true;
	@Input() document_type: any = '30';
	@Input() payments: any = [];
	@Input() credits: any = [];

	//not being sent in the header. on time
	@Input() orderno: any;
	@Input() debtorno: any;
	@Input() branchcode: any;

	@Output() payments_added = new EventEmitter < any > ();
	@Output() payments_removed = new EventEmitter < any > ();
	@Output() credit_removed = new EventEmitter < any > ();
	@Output() giftcard_removed = new EventEmitter < any > ();

	@ViewChild('amountId') amountIdRef: ElementRef;
	@ViewChild('gcModal') gcModalRef: ElementRef;

	paymentmethods: any = false
	bankaccounts: any = false;
	loadingcards = false;
	default_payment = '';
	change_due: any = false;

	hasprofile: any = false;
	profile_cards: any = false;
	payment_card: any = false;
	card_required: any = false;
	preselected_payment: any = false;
	color = 'blue'
	balance_due: any = 0.00;
	refund = new UntypedFormControl(false);
	numpad: number;
	keypadresult: any = false;
	creditAmt: any = false;
	giftCardAmt: any = false;
	appliedCredits: any = false;
	appliedGiftCards: any = false;
	giftcardselect: any = [];
	cardNumberSearch = new UntypedFormControl('');
	

	availableTerminals: Terminal[] = [];
	selectedTerminal: Terminal | null = null;
	terminalTransactionInProgress = false;
	hasTerminalConfigured = false;
	// Terminal must be EXPLICITLY armed before ADD will charge a card. Armed on load
	// (one-tap first charge) and disarmed after every add so a blind ADD on the reset
	// form can never fire a card/terminal charge the operator didn't choose.
	terminalSelected = false;
	useOtherPaymentMethod = false;
	terminalFallback = false;
	posCardpointeEnabled = false;
	// Opt-in (assets config features.posCardOnFile). When a terminal is configured,
	// this surfaces the stored-card / profile charge as an option alongside the device.
	posCardOnFileEnabled = false;
	// True while the add-card modal is open.
	addingCardOnFile = false;
	// One card path per order: once a terminal charge succeeds we drop the card-on-file
	// option, and vice versa — never mix the two gateway charge mechanisms.
	// 'terminal' | 'profile' | null
	cardPathTaken: any = null;
	// Re-entry guard for the card-on-file charge (prevents double-tap double-charge).
	submitting = false;
	// On-screen number pad. Default: expanded only when there's NO terminal AND
	// card-on-file is off (manual amount entry is then the primary path); otherwise
	// collapsed to keep Amount + ADD + COMPLETE visible. User toggle wins after that.
	showKeypad = false;
	private keypadUserToggled = false;
	@ViewChild('addCardModal') addCardModal: TemplateRef<any>;
	private addCardModalRef: any = null;

	constructor(
		private formBuilder: UntypedFormBuilder,
		private globalSearchService: GlobalSearchService,
		private paymentsService: PaymentsService,
		private systemService: SystemService,
		private usersService: UsersService,
		private modalService: NgbModal
	) {
		this.color = this.globalSearchService.color;
	}

	ngOnInit(): void {
		this.globalSearchService.configsubscription.subscribe((cfg: any) => {
			this.posCardpointeEnabled = cfg?.features?.posCardpointe !== false;
			this.posCardOnFileEnabled = cfg?.features?.posCardOnFile === true;
			this.applyKeypadDefault();
		});

		this.globalSearchService.payment_methods.subscribe((results: any) => {
			if(results) {
				this.paymentmethods = results.filter((result: any) => result.pos_enabled === '1');
				this.cardPathTaken = this.cardPathFromPaymentResults(this.payments);
			} else {
				this.getPaymentMethods();
			}
		});

		this.globalSearchService.bankaccounts.subscribe((results: any) => {
			this.bankaccounts = results;
		});

		this.loadUserTerminals();
		this.resetPayForm();

		this.cardNumberSearch.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe( newValue => {
			if(newValue != '') {
				const data = { 'cardnumber': newValue };
				this.systemService.checkCardNumber(data).subscribe( r => {
					if(r.error == '') {
						this.giftcardselect = [];
						r.card.balance = r.balance;
						this.giftcardselect.push(r.card);
					} else if (r.cards) {
					this.giftcardselect = r.cards;
					} else {
						this.giftcardselect = [];
					}
				});
			}
		})
	}
	gcSelected(card: any){
	this.paymentForm.get('reference').setValue(card.giftcard_number);
	this.modalService.dismissAll();
	}
	loadUserTerminals() {
		const userVal = this.globalSearchService.user.getValue();
		const user = userVal?.user || userVal;
		if (!user?.userid) {
			this.hasTerminalConfigured = false;
			this.availableTerminals = [];
			this.selectedTerminal = null;
			this.applyKeypadDefault();
			return;
		}
		this.usersService.getUserTerminals({ userid: user.userid }).subscribe(
			(rows: any) => {
				const list = Array.isArray(rows)
					? rows.map((t: any) => this.normalizeTerminal(t))
					: [];
				this.availableTerminals = list;
				this.hasTerminalConfigured = list.length > 0;
				this.terminalSelected = this.hasTerminalConfigured;
				this.selectedTerminal = this.getDefaultTerminal(list);
				this.applyKeypadDefault();
			},
			() => {
				this.hasTerminalConfigured = false;
				this.availableTerminals = [];
				this.selectedTerminal = null;
				this.applyKeypadDefault();
			}
		);
	}

	private getDefaultTerminal(terminals: Terminal[]): Terminal | null {
		if (!terminals || !terminals.length) {
			return null;
		}
		const defaultTerminal = terminals.find((terminal: any) => {
			if (terminal?.is_default || terminal?.default) {
				return true;
			}
			const config = terminal?.connection_config;
			return !!(config && config.default);
		});
		return defaultTerminal || terminals[0];
	}

	private normalizeTerminal(t: any): Terminal {
		return {
			terminal_id: t.terminal_id,
			terminal_name: t.terminal_name || 'Unnamed Terminal',
			terminal_type: t.terminal_type,
			terminal_model: t.terminal_model || 'desk5000',
			terminal_serial: t.terminal_serial || '',
			connection_type: (t.connection_type || 'lan') as Terminal['connection_type'],
			is_active: true,
			is_available: true,
			connection_config: typeof t.connection_config === 'string' ? JSON.parse(t.connection_config || '{}') : t.connection_config,
			needs_registration: false
		};
	}


	getPaymentMethods() {
		this.globalSearchService.updatePaymentMethods();
		this.globalSearchService.payment_methods.subscribe((results: any) => {
			if(results) {
				this.paymentmethods = results.filter((result: any) => result.pos_enabled === '1');
			}
		});
	}


	isNegative() {
		return (this.financial(this.paymentForm.get('amount').value) < 0)
	}

	makeNegativePayment() {
		//Math.abs()
		const newvalue = -1 * this.financial(this.paymentForm.get('amount').value);
		if (newvalue > 1) {
			this.refund.setValue(false);
		} else {
			this.refund.setValue(true);
		}

		this.paymentForm.get('amount').setValue(newvalue)
	}

	addPaymentInput() {
		this.resetPayForm();
	}

	addPayment() {
		// Only charge the card terminal when it is explicitly armed. After a payment is
		// added the form resets (useOtherPaymentMethod=false, type=''), which used to look
		// identical to "terminal armed" and silently charged a card on the next ADD.
		if (this.hasTerminalConfigured && this.terminalSelected && !this.useOtherPaymentMethod) {
			this.handleTerminalPayment();
			return;
		}
		if (this.submitting) { return; }
		if (this.paymentForm.get('type').value == '') {
			this.globalSearchService.showNotification('Payment Type Required', 'danger', 'bottom', 'right');
			return false;
		}
		const selectedMethod = this.getPaymentMethodByName(this.paymentForm.get('type').value);
		if (this.isGiftCard(selectedMethod)) {
			this.card_required = false;
			this.paymentForm.get('charge_card').setValue(false);
			this.paymentForm.get('card_selected').setValue(false);
		}
		if (this.requiresSavedCardSelection() && !this.paymentForm.get('card_selected').value) {
			this.globalSearchService.showNotification('Select a saved card', 'warning', 'bottom', 'right');
			return false;
		}
		if (this.paymentForm.valid && this.financial(this.paymentForm.get('amount').value)) {
			const isCardOnFile = !!this.paymentForm.get('card_selected').value;
			const data = {
				payment: this.paymentForm.value,
				order: {
					orderno: (this.order_header.orderno) ? this.order_header.orderno : '1',
					debtorno: this.order_header.debtorno,
					branchcode: this.order_header.branchcode,
					document_type: this.document_type
				}
			};
			if (this.getBalance() != 0) {
				this.submitting = true;
				this.paymentsService.addPayment(data).subscribe((results: any[]) => {
					this.submitting = false;
					if(results['message'] && results['message'] != ''){
						this.globalSearchService.showNotification(results['message'], 'warning', 'bottom', 'right');
					}
					// Card-on-file was added to payment_cart. The gateway charge happens at completion.
					if (isCardOnFile && results['success'] !== false) {
						this.cardPathTaken = this.cardPathFromPaymentResults(results) || 'profile';
					}
					this.payments_added.emit(false);
					this.resetPayForm();

				}, () => { this.submitting = false; });
			}
		}
	}

	handleTerminalPayment() {
		const terminalPaymentType = this.getTerminalPaymentType();
		if (!terminalPaymentType) {
			this.globalSearchService.showNotification('No valid payment method available for terminal payments', 'warning', 'bottom', 'right');
			return;
		}
		if (!this.selectedTerminal) {
			this.globalSearchService.showNotification('Please select a terminal', 'warning', 'bottom', 'right');
			return;
		}

		const balance = this.getBalance();
		if (balance <= 0) {
			const message = balance === 0
				? 'Order is already fully paid'
				: 'Order is overpaid. Cannot process terminal payment.';
			this.globalSearchService.showNotification(message, 'warning', 'bottom', 'right');
			return;
		}

		this.paymentForm.get('type').setValue(terminalPaymentType);
		this.card_required = false;
		this.openTerminalTransactionModal();
	}

	openTerminalTransactionModal() {
		const balance = this.getBalance();

		if (balance <= 0) {
			const message = balance === 0
				? 'Order is already fully paid'
				: 'Order is overpaid. Cannot process terminal payment.';
			this.globalSearchService.showNotification(message, 'warning', 'bottom', 'right');
			return;
		}
		const amountControl = this.paymentForm?.get('amount');
		const requestedAmount = this.financial(amountControl?.value);
		if (requestedAmount > balance) {
			this.globalSearchService.showNotification('Amount exceeds remaining balance', 'warning', 'bottom', 'right');
			return;
		}
		const chargeAmount = requestedAmount > 0 ? requestedAmount : this.financial(balance);

		this.terminalTransactionInProgress = true;
		const modalRef = this.modalService.open(TerminalTransactionModalComponent, {
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});

		modalRef.componentInstance.terminal = this.selectedTerminal;
		modalRef.componentInstance.amount = chargeAmount;
		modalRef.componentInstance.orderData = {
			debtorno: this.debtorno,
			branchcode: this.branchcode,
			orderno: this.orderno
		};
		modalRef.componentInstance.invoice = this.orderno != null ? String(this.orderno) : undefined;
		const userVal = this.globalSearchService.user.getValue();
		const user = userVal?.user || userVal;
		const empcode = this.globalSearchService.empCode?.getValue?.();
		modalRef.componentInstance.clerkId = (empcode != null && empcode !== '') ? String(empcode) : (user?.userid != null ? String(user.userid) : undefined);

		modalRef.result.then(
			(result) => {
				this.terminalTransactionInProgress = false;
				if (result.success) {
					if (result.ecr_print_success === false && result.ecr_print_error) {
						this.globalSearchService.showNotification(`ECR printing failed: ${result.ecr_print_error}`, 'warning', 'bottom', 'right');
					}
					this.addTerminalPayment(result);
				}
			},
			(dismissed) => {
				this.terminalTransactionInProgress = false;
				this.globalSearchService.showNotification('Terminal transaction cancelled', 'info', 'bottom', 'right');
			}
		);
	}

	addTerminalPayment(transactionResult: any) {
		const terminalAmount = transactionResult.amount || this.financial(this.getBalance());
		const terminalPaymentType = this.getTerminalPaymentTypeFromResult(transactionResult) || this.getTerminalPaymentType();
		if (!terminalPaymentType) {
			this.globalSearchService.showNotification('No valid payment method available for terminal payments', 'warning', 'bottom', 'right');
			return;
		}
		const remainingAfterPayment = this.financial(this.getBalance()) - this.financial(terminalAmount);
		const shouldAutoComplete = remainingAfterPayment <= 0;

		const data = {
			payment: {
				...this.paymentForm.value,
				type: terminalPaymentType,
				amount: terminalAmount,
				terminal_transaction_id: transactionResult.terminal_transaction_id,
				terminal_id: transactionResult.terminal_id,
				terminal_status: transactionResult.status,
				transaction_type: transactionResult.transaction_type,
				auth_code: transactionResult.auth_code,
				card_last_four: transactionResult.card_last_four,
				card_type: transactionResult.card_type,
				card_type_code: transactionResult.card_type_code,
				entry_method: transactionResult.entry_method,
				entry_mode_code: transactionResult.entry_mode_code,
				response_code: transactionResult.response_code,
				response_text: transactionResult.response_text,
				transaction_sequence: transactionResult.transaction_sequence,
				invoice: transactionResult.invoice,
				reference: transactionResult.reference,
				emv_aid: transactionResult.emv_aid,
				emv_app_label: transactionResult.emv_app_label,
				tip_amount: transactionResult.tip_amount,
				total_amount: transactionResult.total_amount,
				amount_due: transactionResult.amount_due,
				receipt_data: transactionResult.receipt_data,
				client_sent_at: transactionResult.client_sent_at,
				node_received_at: transactionResult.node_received_at,
				print_connect_received_at: transactionResult.print_connect_received_at,
				print_connect_responded_at: transactionResult.print_connect_responded_at,
				node_broadcast_at: transactionResult.node_broadcast_at,
				terminal_response: transactionResult
			},
			order: {
				orderno: this.orderno || '1',
				debtorno: this.debtorno,
				branchcode: this.branchcode,
				document_type: this.document_type
			}
		};

		this.paymentsService.addPayment(data).subscribe(
			(results: any[]) => {
				if (results['message'] && results['message'] != '') {
					this.globalSearchService.showNotification(results['message'], 'warning', 'bottom', 'right');
				}
				// Terminal charge was recorded in payment_cart, so do not mix in card-on-file.
				this.cardPathTaken = 'terminal';
				this.payments_added.emit({ autoCompleteTerminal: shouldAutoComplete });
				this.resetPayForm();
			},
			(error) => {
				this.globalSearchService.showNotification('Failed to record payment', 'danger', 'bottom', 'right');
			}
		);
	}

	removePayment(payment_id: any) {
		//this.payments[index].splice(0,1);
		this.paymentsService.removePayment(payment_id).subscribe((results: any[]) => {
			this.cardPathTaken = this.cardPathFromPaymentResults(results);
			//this.getPayments();
			this.payments_removed.emit(false);
		});

	}

	updatePaymentAmount(event: any, payment: any) {
		payment.amount = event.target.value;
		this.updatePayment(payment)
	}

	updatePaymentType(event: any) {
		const paymentName = event?.value ?? event;

		const thispay = this.paymentmethods.filter(p => {
			return p.paymentname === paymentName
		})[0];

		if (thispay) {
			// Only require / show a saved card when CardConnect POS is enabled. When it's
			// disabled (e.g. AA: features.posCardpointe=false) a card method must NOT surface
			// the cards-on-file picker — it's a plain recorded card payment.
			if (thispay.cc_process != '0' && !this.isGiftCard(thispay) && this.posCardpointeEnabled) {
				this.card_required = true;
			} else {
				this.card_required = false;
				this.paymentForm.get('card_selected').setValue(false);
				this.paymentForm.get('charge_card').setValue(false);
			}
		}
	}

	getBalance() {
		const total = this.totals && Array.isArray(this.totals)
			? this.totals.filter(t => t.code === 'total')[0]
			: null;

		let total_amount = 0.00;

		if (total && this.totals.length) {
			total_amount = total.text
		}

		const value = this.financial(total_amount) - this.financial(this.getTotalPayment());
		if (value < 0) {
			const hasCash = this.payments.some((pay) => this.openCashDroor(pay.payment_type_id));
			this.change_due = hasCash ? value : 0;
		} else {
			this.change_due = 0;
		}

		return value;
	}

	updatePaymentReference(event: any, payment: any) {
		payment.reference = event.target.value;
		this.updatePayment(payment)
	}

	updatePaymentBank(event: any, payment: any) {
		payment.bankaccount = event.target.value;
		this.updatePayment(payment)
	}

	updatePayment(payment: any) {
		//this.payments[index].splice(0,1);
		this.paymentsService.updatePayment(payment).subscribe((results: any[]) => { this.payments = results });
		this.getPayments();
	}

	resetPayForm() {
		this.useOtherPaymentMethod = false;
		this.terminalFallback = false;
		// Disarm the terminal after every add — the operator must re-tap Terminal to
		// charge again, so a blind ADD on the reset form never fires a card charge.
		this.terminalSelected = false;
		const account = resolveDefaultBankAccountCode(
			this.bankaccounts,
			this.globalSearchService.company.getValue()?.defaultBankAccount
		);

		this.paymentForm = this.formBuilder.group({
			reference: [''],
			amount: [this.balance_due, [Validators.required]],
			type: [this.default_payment, [Validators.required]],
			bankaccount: [account, [Validators.required]],
			card_selected: [false],
			charge_card: [false],
		});

		this.setBalanceValue();
	}
	
	giftcardSearch(){
		this.cardNumberSearch.setValue(this.paymentForm.get('reference').value);
		this.modalService.open(this.gcModalRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {}, (reason) => {});
	
	}

	private getTerminalPaymentTypeFromResult(transactionResult: any): string | null {
		const cardType = transactionResult?.card_type?.trim();
		if (!cardType || !this.paymentmethods?.length) {
			return null;
		}
		const lower = cardType.toLowerCase();
		const match = this.paymentmethods.find((method: any) =>
			(method.paymentname || '').toLowerCase() === lower
		);
		return match?.paymentname || null;
	}

	private getTerminalPaymentType(): string | null {
		if (!this.paymentmethods || !this.paymentmethods.length) {
			return null;
		}
		const cardMethod = this.paymentmethods.find((method: any) => method.cc_process != '0' && !this.isGiftCard(method));
		return cardMethod?.paymentname || this.paymentmethods[0]?.paymentname || null;
	}

	private isGiftCard(method: any): boolean {
		return String(method?.payment_code || '').toUpperCase() === 'GC';
	}

	private showGCButton(){
		let value = false;
		if (this.paymentmethods) {
			const thispay = this.paymentmethods.filter(p => {
				return p.paymentname == this.paymentForm.get('type').value
			})[0];
			if (thispay) {
				if (String(thispay?.payment_code || '').toUpperCase() === 'GC') {
					value = true;
				}
			}
		}

		return value;
	}
	private cardPathFromPaymentResults(results: any): any {
		const rows = Array.isArray(results) ? results : (Array.isArray(results?.payments) ? results.payments : this.payments);
		if (!rows || !rows.length) {
			return null;
		}
		const paths = rows
			.map((pay: any) => this.cardPathFromPayment(pay))
			.filter((path: any) => !!path);
		if (paths.indexOf('terminal') !== -1) {
			return 'terminal';
		}
		return paths.indexOf('profile') !== -1 ? 'profile' : null;
	}

	private cardPathFromPayment(pay: any): any {
		if (!pay) {
			return null;
		}
		if (pay.terminal_transaction_id) {
			return 'terminal';
		}
		if (pay.options && typeof pay.options === 'object' && pay.options.card_id) {
			return 'profile';
		}
		const method = this.paymentMethodFromPayment(pay);
		if (method && method.cc_process != '0' && !this.isGiftCard(method)) {
			return 'terminal';
		}
		return null;
	}

	private paymentMethodFromPayment(pay: any): any {
		if (!this.paymentmethods || !this.paymentmethods.length) {
			return null;
		}
		return this.paymentmethods.find((method: any) =>
			String(method.paymentid) === String(pay.payment_type_id)
			|| method.paymentname === pay.payment_type
		);
	}

	// When a terminal is configured, only credit/debit cards go through the device.
	// Everything else — cash, check, gift cards — is taken manually alongside it.
	nonCardPaymentMethods(): any[] {
		if (!this.paymentmethods || !this.paymentmethods.length) {
			return [];
		}
		return this.paymentmethods.filter((method: any) => method.cc_process == '0' || this.isGiftCard(method));
	}

	// Switch back to the terminal as the default payment path.
	selectTerminalPayment() {
		this.useOtherPaymentMethod = false;
		this.terminalFallback = false;
		this.terminalSelected = true;
		this.card_required = false;
		this.addingCardOnFile = false;
		// Drop any selected/auto-selected saved card so the terminal path never carries one.
		this.paymentForm.get('card_selected').setValue(false);
		const typeControl = this.paymentForm?.get('type');
		if (typeControl) {
			typeControl.setValue('');
		}
		this.setBalanceValue();
	}

	// Terminal is unavailable — fall back to the full manual list (card methods
	// included). Card selections are recorded, not run on the device; the card
	// selector's "Do not charge" option records an externally-run or hand-keyed
	// card without touching the processor.
	enableTerminalFallback() {
		this.terminalFallback = true;
		this.useOtherPaymentMethod = true;
		this.terminalSelected = false;
		this.addingCardOnFile = false;
		this.card_required = false;
		// Manual entry: never carry a selected saved card into the charge.
		this.paymentForm.get('card_selected').setValue(false);
		const typeControl = this.paymentForm?.get('type');
		if (typeControl) {
			typeControl.setValue('');
		}
	}

	// Use card on file: enabled by config AND the customer has at least one stored card.
	canUseCardOnFile(): boolean {
		return this.posCardOnFileEnabled && this.hasStoredCards();
	}

	private hasStoredCards(): boolean {
		return !!(this.profile_cards && this.profile_cards.length);
	}

	private requiresSavedCardSelection(): boolean {
		return this.useOtherPaymentMethod
			&& this.card_required
			&& !this.terminalFallback
			&& !this.addingCardOnFile
			&& this.hasStoredCards();
	}

	// Queue a stored profile card instead of running the physical terminal.
	// Selecting a card method drives card_required = true, which renders the
	// saved-card picker. addPayment writes payment_cart; completion charges it.
	selectCardOnFilePayment() {
		this.useOtherPaymentMethod = true;
		this.terminalFallback = false;
		this.terminalSelected = false;
		this.addingCardOnFile = false;
		const cardMethodName = this.getTerminalPaymentType();
		if (cardMethodName) {
			this.paymentForm.get('type').setValue(cardMethodName);
			const paymentid = this.getPaymentIdFromName(cardMethodName);
			if (paymentid) {
				this.setCardRequired(paymentid);
			}
		}
	}

	// Pick a saved card in the custom card-on-file picker (replaces the old mat-select).
	selectSavedCard(card: any) {
		this.paymentForm.get('card_selected').setValue(card || false);
		this.changeCard(card || false);
		if (card) {
			// Picking a saved card IS choosing the card-on-file path — switch off the
			// terminal so addPayment() charges the profile, not the terminal.
			this.useOtherPaymentMethod = true;
			this.card_required = true;
		}
	}

	// Remove a card from the customer's gateway profile, then refresh the list.
	removeSavedCard(card: any, event?: Event) {
		if (event) { event.stopPropagation(); }
		if (!card || !confirm('Remove this card from the customer\'s profile?')) { return; }
		const remove = {
			debtorno: this.debtorno || this.order_header?.debtorno,
			branchcode: this.branchcode || this.order_header?.branchcode,
			name: this.order_header?.name || card.name,
			ccnumber: card.number,
			expiry: (card.expiry_month || '') + '/' + (card.expiry_year || ''),
			card_id: card.card_id,
		};
		this.loadingcards = true;
		this.paymentsService.removeCreditCard(remove).subscribe((result: any) => {
			this.loadingcards = false;
			if (result && result.cards !== undefined) {
				const c = result.cards;
				this.profile_cards = c ? (Array.isArray(c) ? c : [c]) : [];
				this.hasprofile = this.profile_cards.length > 0;
				if (this.paymentForm.get('card_selected').value === card) {
					this.paymentForm.get('card_selected').setValue(false);
				}
			} else {
				this.loadProfile(this.debtorno, this.branchcode);
			}
		});
	}

	// Font Awesome brand glyph for a saved card.
	cardBrandIcon(card: any): string {
		const t = String(card?.card_type || '').toLowerCase();
		if (t.includes('visa')) return 'fa-cc-visa';
		if (t.includes('master')) return 'fa-cc-mastercard';
		if (t.includes('amex') || t.includes('american')) return 'fa-cc-amex';
		if (t.includes('disc')) return 'fa-cc-discover';
		return 'fa-credit-card';
	}

	// Last four digits for display.
	cardLast4(card: any): string {
		const raw = String(card?.last_four ?? card?.number ?? card?.display_number ?? '');
		const digits = raw.replace(/\D/g, '');
		return (digits || raw).slice(-4);
	}

	// Add a card to file: enabled by config AND the customer has no stored card yet.
	// (Card-count based, not hasprofile — a profile row with zero cards still needs "add".)
	canAddCardOnFile(): boolean {
		return this.posCardOnFileEnabled && !this.hasStoredCards();
	}

	// Customer context handed to <app-credit-card-form> (cardholder name is editable on the form).
	get cardFormCustomer(): any {
		return {
			debtorno: this.debtorno || this.order_header?.debtorno,
			branchcode: this.branchcode || this.order_header?.branchcode,
			name: this.decodeHtml(this.order_header?.name || this.order_header?.deliverto || '')
		};
	}

	toggleKeypad() {
		this.keypadUserToggled = true;
		this.showKeypad = !this.showKeypad;
	}

	// Initial keypad state: expanded only when manual entry is the only way to pay
	// (no terminal AND no card-on-file). Re-run as terminals/config resolve; never
	// overrides a manual toggle.
	private applyKeypadDefault() {
		if (this.keypadUserToggled) { return; }
		this.showKeypad = !this.hasTerminalConfigured && !this.posCardOnFileEnabled;
	}

	// Decode HTML entities (e.g. "BOB &amp; PAGE" -> "BOB & PAGE"). innerText is safe — it won't execute markup.
	private decodeHtml(value: any): string {
		if (value === null || value === undefined || value === '') { return ''; }
		const div = document.createElement('div');
		div.innerHTML = String(value);
		return div.innerText;
	}

	// Reveal the card-entry form to store a new card on the customer's profile.
	startAddCardOnFile() {
		this.useOtherPaymentMethod = true;
		this.terminalFallback = false;
		this.terminalSelected = false;
		this.addingCardOnFile = true;
		// Hand-entering a card: clear any selected saved card so we never charge it.
		this.paymentForm.get('card_selected').setValue(false);
		this.changeCard(false);
		this.addCardModalRef = this.modalService.open(this.addCardModal, {
			centered: true,
			backdrop: 'static',
			windowClass: 'cof-modal',
		});
		this.addCardModalRef.result.then(() => this.addingCardOnFile = false, () => this.addingCardOnFile = false);
	}

	closeAddCardModal() {
		this.addingCardOnFile = false;
		if (this.addCardModalRef) {
			this.addCardModalRef.dismiss();
			this.addCardModalRef = null;
		}
	}

	// credit-card-form stored the card and returned the refreshed profile. Adopt the
	// new cards and drop straight into the card-on-file selection path.
	onCardOnFileAdded(result: any) {
		// Card saved → adopt the refreshed list, close the modal, and reveal the
		// picker so the operator can select the new card.
		const cards = result && Array.isArray(result.cards) ? result.cards : [];
		if (cards.length) {
			this.hasprofile = true;
			this.profile_cards = cards;
		}
		this.closeAddCardModal();
		this.selectCardOnFilePayment();
		const selectedCard = cards.find((card: any) => !!card.default) || cards[cards.length - 1] || cards[0];
		if (selectedCard) {
			this.selectSavedCard(selectedCard);
		}
		// Reload from the gateway to be sure the list is current, then show the picker.
		this.loadProfile(this.debtorno || this.order_header?.debtorno, this.branchcode || this.order_header?.branchcode);
	}

	getPayments() {

		this.payments_added.emit(false);
	}

	balance(): number {
		
		let balance = 0.00;
		if (this.payments && this.payments.length > 0) {

			const payment_total = this.payments.reduce(function(accumulator, am) {
				return accumulator + parseFloat(am.amount);;
			}, 0);

			balance = this.financial(this.totals.total) - this.financial(payment_total);
		}

		this.balance_due = this.financial(balance)
		return this.financial(balance);
	}

	getTotalPayment() {
		let total = 0.00
		if (this.payments && this.payments.length > 0) {
			total = this.payments.reduce(function(accumulator, am) {
				return accumulator + parseFloat(am.amount);;
			}, 0);
		}

		total = this.financial(total + this.creditAmt + this.giftCardAmt);
		return total;
	}


	changeCard(event: any) {
		if (event && event.card_type) {
			this.paymentForm.get('type').setValue(event.card_type);
		}
	}

	lastFour(value: any) {
		return 'XX' + value.substr(value.length - 4);
	}

	formatCardOptionLabel(method: any): string {
		if (!method) {
			return '';
		}
		const raw = String(method.display_number ?? method.number ?? '').trim();
		if (!raw) {
			return '';
		}
		if (/^TOKEN/i.test(raw)) {
			const lf = String(method.last_four ?? '').replace(/\D/g, '');
			if (lf.length >= 4) {
				return 'XXXXXXXXXXXX' + lf.slice(-4);
			}
			const tail = raw.replace(/\D/g, '').slice(-4);
			if (tail.length === 4) {
				return 'XXXXXXXXXXXX' + tail;
			}
			return 'Card on file';
		}
		return raw;
	}

	ngOnChanges(changes: any) {
		if (changes.debtorno) {
			this.cardPathTaken = null;   // new order/customer — both card paths open again
			this.getPayments();
			this.loadProfile(this.debtorno, this.branchcode);

			if (changes.order_header?.currentValue?.preselectedpay) {
				this.preselected_payment = changes.order_header.currentValue.preselectedpay;
			}
		}

		if (changes.order_header) {
			// Handle order header changes if needed
		}

		// Remove duplicate payment change handler - consolidate into one
		if (changes.payments) {
			if (changes.payments.currentValue && changes.payments.currentValue.length) {
				this.cardPathTaken = this.cardPathFromPaymentResults(changes.payments.currentValue);
				// When payments change, update balance (setBalanceValue handles untouched/default checks)
				if (this.paymentForm) {
					this.setBalanceValue();
				}
			} else {
				this.cardPathTaken = null;
			}
		}

		if (this.paymentForm) {
			if (this.paymentForm.untouched) {
				if (this.bankaccounts && Array.isArray(this.bankaccounts) && this.bankaccounts.length) {
					this.paymentForm.get('bankaccount').setValue(resolveDefaultBankAccountCode(
						this.bankaccounts,
						this.globalSearchService.company.getValue()?.defaultBankAccount
					))
				}
			}

			if (!this.profile_cards && this.preselected_payment && this.paymentForm && this.posCardpointeEnabled) {
				this.loadingcards = true;
				this.paymentsService.loadProfile(this.debtorno, this.branchcode).subscribe(async (result: any) => {
					this.loadingcards = false;
					if (result.cards) {
						this.hasprofile = true;
						this.profile_cards = result.cards
						this.paymentForm.get('type').setValue(this.preselected_payment.card_type);

						const card = this.profile_cards.filter((c: any) => {
							return c.card_id === this.preselected_payment.card_id;
						})[0];
						this.paymentForm.get('card_selected').setValue(card);
						const paymentid = this.getPaymentIdFromName(this.preselected_payment.card_type);
						this.setCardRequired(paymentid)
					} else {
						this.hasprofile = false;
						this.profile_cards = [];
						this.payment_card = false;
					}
				});
			}

			// Only update balance if form is untouched
			if (this.payments && this.paymentForm.untouched) {
				this.setBalanceValue();
			}

			this.balance();
		}

		if(changes.debtorno){
			this.getPayments();
		}

		if(changes.credits){
			let amt = 0;
			if(changes.credits.currentValue.length && changes.credits.currentValue[0]){
				this.appliedCredits = changes.credits.currentValue;
				(this.appliedCredits).forEach(cr => {
					amt += cr.applied;
				});
				this.creditAmt = amt;
			}else{
				this.creditAmt = 0;
				this.appliedCredits = [];
			}
			// Only update amount if form is untouched
			if (this.paymentForm && this.paymentForm.untouched) {
				this.setBalanceValue();
			}
		}
		
		if(changes.giftcards){
			let amt = 0;
			if(changes.giftcards.currentValue.length && changes.giftcards.currentValue[0]){
				this.appliedGiftCards = changes.giftcards.currentValue;
				(this.appliedGiftCards).forEach(cr => {
					amt += cr.applied;
				});
				this.giftCardAmt = amt;
			}else{
				this.giftCardAmt = 0;
				this.appliedGiftCards = [];
			}
			// Only update amount if form is untouched
			if (this.paymentForm && this.paymentForm.untouched) {
				this.setBalanceValue();
			}
		}
	}

	setBalanceValue(): void {
		const balance = this.getBalance();
		const amountControl = this.paymentForm?.get('amount');

		if (!amountControl) {return;}

		const currentValue = parseFloat(amountControl.value) || 0;
		const isDefaultValue = currentValue === 0 || currentValue === balance;
		const isUntouched = this.paymentForm.untouched;
		const isAmountDirty = amountControl.dirty || amountControl.touched;

		// If form is untouched (reset state) AND amount field hasn't been manually edited, update to current balance
		// Otherwise, only auto-set if field is in default state (preserves user input)
		// Never override user's manual input - allow amount to be changed before payment type selection
		if ((isUntouched && !isAmountDirty) || (isDefaultValue && !isAmountDirty)) {
			if (balance >= 0) {
				amountControl.setValue(this.financial(balance));
			} else {
				amountControl.setValue(0.00);
			}
		}
		// Otherwise, preserve user's manual input
	}

	getPaymentIdFromName(name: any) {
		if (this.paymentmethods) {
			const type = this.paymentmethods.filter(p => {
				return p.paymentname === name
			})[0];

			if (type) {
				return type.paymentid;
			}
		}
		return false;

	}

	loadProfile(debtorno: any, branchcode: any) {
	
	//This is duuuuumb
		this.globalSearchService.configsubscription.subscribe((cfg: any) => {
			this.posCardpointeEnabled = cfg?.features?.posCardpointe !== false;
		
		if (!this.posCardpointeEnabled) {
			this.hasprofile = false;
			this.profile_cards = [];
			this.payment_card = false;
			this.paymentForm.get('card_selected').setValue(false);
			return;
		}
		this.loadingcards = true;
		this.paymentsService.loadProfile(debtorno, branchcode).subscribe(async (result: any) => {
			this.loadingcards = false;
			if (result.cards) {
				this.hasprofile = true;
				this.profile_cards = result.cards;
				// Re-bind an existing selection to the freshly-loaded card instance. The
				// template highlights the active card by object identity, so a reload (e.g.
				// right after adding a card) would otherwise drop the highlight even though a
				// card is still selected. Match by card_id and re-point at the new object.
				const sel = this.paymentForm.get('card_selected').value;
				if (sel && sel.card_id) {
					const match = result.cards.find((c: any) => String(c.card_id) === String(sel.card_id));
					this.paymentForm.get('card_selected').setValue(match || false);
				}

			} else {
				this.hasprofile = false;
				this.profile_cards = [];
				this.payment_card = false;
				this.paymentForm.get('card_selected').setValue(false);
			}
		});
		});
	}

	addOnRequired() {

		let value = false;
		if (this.paymentmethods) {
			const thispay = this.paymentmethods.filter(p => {
				return p.paymentname == this.paymentForm.get('type').value
			})[0];
			if (thispay) {
				if (thispay.additionalrequired == '1') {
					value = true;
				}
			}
		}

		return value;
	}
	openCashDroor(method: any) {

		let value = false;
		if (this.paymentmethods) {
			const thispay = this.paymentmethods.filter(p => {
				return p.paymentid == method
			})[0];
			if (thispay) {
				if (thispay.opencashdrawer == '1') {
					value = true;
				}
			}
		}

		return value;
	}

	setCardRequired(method: any) {
		if (!this.posCardpointeEnabled) {
			this.card_required = false;
			return;
		}
		if (method) {
			const thispay = this.paymentmethods.filter(p => {
				return p.paymentid == method
			})[0];

			if (thispay) {

				if (thispay.cc_process !== '0' && !this.isGiftCard(thispay)) {
					this.card_required = true;
				} else {
					this.card_required = false;
					this.paymentForm.get('charge_card').setValue(false);
					this.paymentForm.get('card_selected').setValue(false);
				}
			}
		}
	}

	financial(x) {

		if (Number.isNaN(x)) {
			x = 0
		}

		return parseFloat(Number.parseFloat(x).toFixed(2));
	}


	runKey(value: any) {
		const amountControl = this.paymentForm.get('amount');

		switch (value) {
		case 'add':
			this.addPayment();
			break;
		case 'backspace':
			const newvalue = (this.paymentForm.get('amount').value + '').slice(0, -1);
			if (newvalue != '') {
				this.paymentForm.get('amount').setValue(newvalue);
			} else {
				this.paymentForm.get('amount').setValue(0.00);
			}
			amountControl.markAsTouched();
			break;
		case 'minus':
			this.makeNegativePayment()
			amountControl.markAsTouched();
			break;
		case '0':
		case '.':
			var periodval = this.paymentForm.get('amount').value + '' + value;
			this.paymentForm.get('amount').setValue(periodval);
			amountControl.markAsTouched();
			break;
		default:
			const currentvalue = this.paymentForm.get('amount').value + '' + value;
			this.paymentForm.get('amount').setValue(this.financial(currentvalue));
			amountControl.markAsTouched();
			break;
		}
	}

	setChargeType(event: MatButtonToggleChange) {
		const selectedPaymentName = event.value;
		const method = this.getPaymentMethodByName(selectedPaymentName);

		if (selectedPaymentName) {
			// Picking a method means "not the terminal" — record it directly.
			if (this.hasTerminalConfigured) {
				this.useOtherPaymentMethod = true;
				this.terminalSelected = false;
			}
			const paymentFormControl = this.paymentForm.get('type');
			if (paymentFormControl) {
				paymentFormControl.setValue(selectedPaymentName);
			}

			this.updatePaymentType(selectedPaymentName);
			this.setCardRequired(method.paymentid);

			setTimeout(() => {
				this.amountIdRef.nativeElement.focus();
				if (method?.opencashdrawer !== '1') {
					const currentAmount = parseFloat(this.paymentForm.get('amount').value) || 0;
					const balance = this.getBalance();
					const amountControl = this.paymentForm.get('amount');
					const isAmountDirty = amountControl.dirty || amountControl.touched;

					// Only auto-set if amount is 0 or matches balance AND user hasn't manually edited it
					// This allows users to change amount first, then select payment type for split payments
					if (!isAmountDirty && (currentAmount === 0 || currentAmount === balance)) {
						this.setBalanceValue();
					}
				}
			}, 0);
		}
	}

	getPaymentMethodByName(paymentname: string) {
		return this.paymentmethods.find(method => method.paymentname === paymentname);
	}

	ngAfterViewInit(): void {


	}

	removeCredit(credit){
		this.credit_removed.emit(credit);
	}

}
